export enum VideoOptOutReasons {
    AudioVideoDeviceNotDetected = 'AudioVideoDeviceNotDetected',
    PublishingError = 'VideoPublishingError',
    RecordingFailure = 'VideoRecordingFailure'
}